module.exports = __webpack_public_path__ + "img/defaultAvatar.57d70f74.png";